import React from "react";

const PrivacyPolicy = () => {
  const today = new Date().toLocaleDateString();

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1>Privacy Policy</h1>
        <p><strong>Effective Date:</strong> {today}</p>

        <p>
          Chris OnSite Auto Detailing (“we,” “our,” or “us”) respects your privacy
          and is committed to protecting your personal information. This Privacy
          Policy explains how information is collected, used, and protected when
          you visit ChrisOnSite.com or contact us by phone or message.
        </p>

        <h2>1. Information We Collect</h2>
        <p>
          We may collect the following information when you interact with our
          website or contact us:
        </p>
        <ul>
          <li>Name</li>
          <li>Phone number</li>
          <li>Email address (if provided)</li>
          <li>Vehicle or service details</li>
          <li>Any information you voluntarily provide in messages or calls</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Respond to service inquiries</li>
          <li>Schedule appointments</li>
          <li>Provide customer support</li>
          <li>Send service-related messages or updates</li>
          <li>Improve our services</li>
        </ul>
        <p>
          We do <strong>not</strong> sell or rent your personal information to
          third parties.
        </p>

        <h2>3. Phone Calls and Messaging</h2>
        <p>When you contact us by phone or text:</p>
        <ul>
          <li>
            Your call or message may be routed through a third-party
            communications provider (such as Twilio).
          </li>
          <li>Standard carrier messaging and data rates may apply.</li>
          <li>
            We will only use your phone number to respond to your inquiry or
            provide service-related communication.
          </li>
        </ul>
        <p>
          You may request to stop receiving messages at any time by contacting us.
        </p>

        <h2>4. Cookies and Website Data</h2>
        <p>Our website may collect limited technical information such as:</p>
        <ul>
          <li>IP address</li>
          <li>Browser type</li>
          <li>Pages visited</li>
        </ul>
        <p>
          This information is used only to maintain and improve the website
          experience.
        </p>

        <h2>5. Data Security</h2>
        <p>
          We take reasonable measures to protect your information from
          unauthorized access, disclosure, or misuse.
        </p>

        <h2>6. Third-Party Services</h2>
        <p>
          We may use trusted third-party services to operate our website and
          communications (such as hosting providers and Twilio). These providers
          only receive the information necessary to perform their services.
        </p>

        <h2>7. Your Rights</h2>
        <p>You may contact us at any time to:</p>
        <ul>
          <li>Request access to your information</li>
          <li>Correct or update your information</li>
          <li>Request deletion of your information</li>
        </ul>

        <h2>8. Contact Information</h2>
        <p>
            <strong>Chris OnSite Auto Detailing</strong><br />
            Phone: +1 (949) 323-4900<br />
            Email: chrishornyak051@gmail.com<br />
            Website: ChrisOnSite.com
        </p>

        <div style={styles.footer}>
          <p>Last updated: {today}</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    background: "#f7f7f7",
    minHeight: "100vh",
    padding: "40px 20px",
    fontFamily: "Arial, sans-serif",
    color: "#222",
  },
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    background: "#fff",
    padding: "30px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    lineHeight: 1.6,
  },
  footer: {
    marginTop: "30px",
    fontSize: "0.9em",
    color: "#555",
  },
};

export default PrivacyPolicy;